import type { AxiosError, AxiosRequestConfig } from 'axios';

import Axios from 'axios';

const apiAxiosInstance = Axios.create({
  paramsSerializer: { indexes: null },
  baseURL:
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.NEXT_PUBLIC_SDK_BASE_URL ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.EXPO_PUBLIC_SDK_BASE_URL ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.SDK_BASE_URL ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.NEXT_PUBLIC_BASE_URL ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.EXPO_PUBLIC_BASE_URL ||
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    process.env.BASE_URL,
});

// Deferred initialization to avoid circular dependency issues in production builds
// The @utility-nyc/react-auth-setup package imports from @utility-nyc/react-query-sdk,
// which creates a circular dependency when this file is loaded synchronously
let interceptorsInitialized = false;

const initializeInterceptors = () => {
  if (interceptorsInitialized) return;
  interceptorsInitialized = true;

  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { setupAxiosInterceptors } = require('@utility-nyc/react-auth-setup');
    setupAxiosInterceptors({
      axiosInstance: apiAxiosInstance,
      shouldAutoLogoutOnFailedSessionRefresh: true,
    });
  } catch (error) {
    // Reset flag so it can be retried
    interceptorsInitialized = false;
    console.error('Failed to initialize axios interceptors:', error);
  }
};

// Use setTimeout to defer execution until after module initialization completes
// This breaks the circular dependency by allowing all modules to load first
setTimeout(initializeInterceptors, 0);

// add a second `options` argument here if you want to pass extra options to each generated query
const customAxios = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> =>
  apiAxiosInstance
    .request({
      ...config,
      ...options,
    })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });

type ErrorType<Error> = AxiosError<Error>;

export { customAxios };
export type { ErrorType };
